import React from 'react';
import { Col, Container, Row } from '@yme/atoms/grid';
import { getColumnNumberForDesktop } from '@yme/components/HomePage/components/helpers';
import { SlideOutAnimationCard } from '@yme/molecules/cards';
import { buildKey, buildRandomValue, buildStateParam } from '@yme/utils/common';
import { AspectRatio } from '@yme/utils/constants';
import { SPECIAL_OFFERS_DESKTOP_TEST_ID, SPECIAL_OFFERS_LG_COLS, SPECIAL_OFFERS_MAX_CARD, } from './constants';
import { calcInternalMargin, calcMarginBottom } from './helpers';
export function DesktopCards({ cards, isRightToLeft }) {
    const cardsElements = cards.map((card, index) => {
        const { backgroundImage, buttonLink, buttonText, description, title } = card;
        return (React.createElement(Col, { lg: getColumnNumberForDesktop(cards.length, SPECIAL_OFFERS_MAX_CARD), key: buildKey(buildStateParam(), buttonText) },
            React.createElement(SlideOutAnimationCard, { key: buildKey(buildRandomValue(), title), backgroundImage: backgroundImage, button: {
                    text: buttonText,
                    link: buttonLink,
                }, description: description, title: title, isRightToLeft: isRightToLeft, desktopGridCols: SPECIAL_OFFERS_LG_COLS, numberOfCards: cards.length, marginBottom: calcMarginBottom(cards.length, index), internalMargin: calcInternalMargin(cards.length), aspectRatio: cards.length === 1 ? AspectRatio.RectangleLevel2 : AspectRatio.RectangleLevel3 })));
    });
    return (React.createElement(Container, { dataTestId: SPECIAL_OFFERS_DESKTOP_TEST_ID, isRightToLeft: isRightToLeft },
        React.createElement(Row, null, cardsElements)));
}
